import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import "../../ClosedLoop/Dashboard.less"
import { withRouter } from "../../../lib/withRouter"
import { formatDate, getViewPatientData, postResource } from "../../../lib"
import moment from "moment"
import RangePicker from "../../ClaimReview/RangePicker"
import { ArrowDownUp } from "lucide-react"

export class MirthXML extends React.Component {
    static propTypes = {
        query: PropTypes.object,
        selection: PropTypes.object,
        location: PropTypes.object,
        settings: PropTypes.object,
        urlParams: PropTypes.object,
        dispatch: PropTypes.func,
        selectedLog: PropTypes.object,
        onClose: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this.state = {
            xmlData: null,
            loading: false,
            error: null,
        };
    }

    componentDidMount() {
        console.log("Selected Referral for Detail View", this.props.selectedLog);
        this.loadXMLFile();
    }

    loadXMLFile = async () => {
        try {
            this.setState({ loading: true });

            let apiUrl = `${this.props.settings.server.baseUrl}/mirth/file/xml?s3Location=${this.props.selectedLog.s3_location}`;

            let data = await getViewPatientData({
                url: apiUrl,
                server: this.props.settings.server,
                Accept: "application/xml",
                dataType: "text"
            });

            // ✅ Clean XML
            let cleanedXML = data
                .replace(/<\?xml-stylesheet.*?\?>/, '')   // remove stylesheet
                .replace(/<!--[\s\S]*?-->/g, '')          // remove comments
                .trim();

            this.setState({
                xmlData: cleanedXML,
                loading: false
            });

        } catch (error) {
            this.setState({ error: error.message, loading: false });
        }
    };

    render() {
        const { selectedLog, onClose } = this.props;
        return (
            <>
                <div className="patient-sidebar-overlay" onClick={onClose}>
                    <div className="patient-sidebar clr-sidebar" onClick={e => e.stopPropagation()}>

                        {/* Header */}
                        <div className="sidebar-header">
                            <h4>{selectedLog?.file_name}</h4>
                            <button className="close-btn" onClick={onClose}>
                                <i className="fa fa-times" />
                            </button>
                        </div>

                        <div style={{ padding: "15px" }}>
                            {selectedLog.error_message && (
                                <div className="panel panel-primary" style={{ marginBottom: '10px' }}>
                                    <div className="panel-heading" style={{ padding: '8px 15px' }}>
                                        <h5 className="panel-title" style={{ margin: 0, fontSize: '14px' }}>
                                            <i className="fa fa-info-circle"></i> Error Message
                                        </h5>
                                    </div>
                                    <div className="panel-body" style={{ padding: '10px 15px' }}>
                                        {selectedLog.error_message}
                                    </div>
                                </div>
                            )}

                            {this.state.loading && <p>Loading...</p>}

                            {this.state.xmlData && (
                                <pre style={{
                                    maxHeight: "85vh",
                                    overflow: "auto",
                                    background: "#1e1e1e",
                                    color: "#d4d4d4",
                                    padding: "15px",
                                    borderRadius: "6px",
                                    fontSize: "12px"
                                }}>
                                    {this.state.xmlData}
                                </pre>
                            )}


                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default connect(state => state)(withRouter(MirthXML));